<script setup lang="ts">
import { computed } from "vue";

import BaseSticker from "@/components/ui/BaseSticker/BaseSticker.vue";
import { stickerName } from "@/components/ui/BaseSticker/baseSticker";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { FieldChange } from "@/model/change";
import { parseStickerString } from "@/utils/sticker";

const props = defineProps<{ field: FieldChange<string> }>();

const oldSticker = computed(() => parseStickerString(props.field.old));
const newSticker = computed(() => parseStickerString(props.field.new));
</script>

<template>
  <div class="change horizontal">
    <template v-if="field.old">
      <span class="change-value">
        <BaseSticker v-if="oldSticker" :sticker="oldSticker" class="sticker" aria-hidden="true" />
        <SvgIcon v-else name="general/sticker" width="20" height="20" aria-hidden="true" />
        {{ stickerName(oldSticker) }}
      </span>
      <SvgIcon
        name="arrow/right"
        width="20"
        height="20"
        role="img"
        :aria-label="$t('label.cardDiff.changedTo')"
      />
    </template>
    <span class="change-value">
      <BaseSticker v-if="newSticker" :sticker="newSticker" class="sticker" aria-hidden="true" />
      <SvgIcon v-else name="general/sticker" width="20" height="20" aria-hidden="true" />
      {{ stickerName(newSticker) }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.sticker {
  width: 20px;
  padding: 0;
}
</style>
